<template>
    <header class="header-component">
        <link
            rel="preload"
            as="image"
            href="/img/gp-logo.svg"
            fetchpriority="high"
        >
        <nav class="navbar fixed-navbar">
            <a href="/">
                <img
                    class="nav-logo"
                    src="/img/gp-logo.svg"
                    alt="logo"
                    width="160"
                    height="71"
                    loading="eager"
                    fetchpriority="high"
                >
            </a>
            <ul :class="[{ 'active': isMenuActive }, 'nav-menu']">
                <li class="nav-item curator" v-if="user && user.user_type === 'agent' && curator && (curatorRequisites || curator.phone)">
                    <p v-if="curatorRequisites || curator.phone">Ваш куратор:</p>
                    <a :href="'tel:+' + curator.phone" class="nav-link" v-if="curator.phone">{{ '+' + curator.phone }}</a>
                    <a
                        :href="'tel:+' + curator.phone"
                        class="nav-link"
                        v-if="curatorRequisites && curatorRequisites.fio && curatorRequisites.fio.surname && curatorRequisites.fio.name"
                    >
                        {{ curatorRequisites.fio.surname + ' ' + curatorRequisites.fio.name }}
                    </a>
                </li>
                <li class="nav-item" v-for="navItem in navItems" :key="navItem.name" v-if="navItem.name">
                    <a @click="openLink(navItem.link)" class="nav-link">{{ navItem.name }}</a>
                </li>
                <li class="nav-item" v-if="user">
                    <span
                        class="user-id-tooltip"
                        :data-user-id="modifiedUserId"
                        @click="copyUserId"
                    >
                        Мой ID
                    </span>
                </li>
                <li class="nav-item" v-if="screenWidth > 1024">
                    <a @click="signOut" :class="[{ 'sign-button': !user }, 'nav-link']">{{ user ? 'Выход' : 'Вход' }}</a>
                </li>
                <li v-if="user && screenWidth > 1024">
                    <v-btn class="submit-button" @click="toDisplay = true">Новый полис</v-btn>
                </li>
                <li class="nav-item" v-if="screenWidth < 1025">
                    <a @click="signOut" class="nav-link">{{ user ? 'Выход' : 'Войти в личный кабинет' }}</a>
                </li>
            </ul>
            <div :class="[{ 'active': isMenuActive }, 'hamburger']" @click="isMenuActive = !isMenuActive; isFixed = true">
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span>
            </div>
        </nav>
        <b2b-policy-type-dialog
            :links="policyTypesArray"
            :hideButton="true"
            :toDisplay="toDisplay"
            @changeDialog="changeDialog"
        ></b2b-policy-type-dialog>
    </header>
</template>

<script>
import PolicyTypeDialogButton from "../elements/PolicyTypeDialogButton.vue";

export default {
    components: {
        'b2b-policy-type-dialog': PolicyTypeDialogButton
    },
    props: [
        'user',
        'curator',
    ],
    data: () => ({
        navItems: [],
        isMenuActive: false,
        scrollPosition: 0,
        isFixed: false,
        screenWidth: 0,
        toDisplay: false,
        curatorRequisites: null,
        policyTypesArray: [
            {
                link: "/osago/new",
                name: "ОСАГО",
            },
            {
                link: "/mortgage/calc",
                name: "Страхование ипотеки",
            },
            {
                link: "/antimite/new",
                name: "Антиклещ",
            },
            {
                link: "/transit-osago",
                name: "ОСАГО не РФ",
            },
        ],
    }),
    mounted() {
        this.onScroll();
        this.onScreenResize();

        if (this.curator && this.curator.requisites) {
            this.curatorRequisites = JSON.parse(this.curator.requisites);
        }
    },
    created() {
        this.screenWidth = window.innerWidth;
        this.scrollPosition = window.scrollY;
        this.changeNavItems(this.screenWidth);

        if (this.user && !this.user.is_transit_open) {
            this.policyTypesArray = this.policyTypesArray.filter(item => item.name !== 'ОСАГО не РФ');
        }
    },
    methods: {
        onScroll() {
            window.addEventListener('scroll', () => {
                this.scrollPosition = window.scrollY;
                if (this.isMenuActive || this.screenWidth < 1025) {
                    this.isFixed = true;
                    return;
                }
                if (this.scrollPosition > window.innerHeight / 2) {
                    this.isFixed = true;
                } else {
                    this.isFixed = false;
                }
            });
        },
        onScreenResize() {
            window.addEventListener("resize", () => {
                this.screenWidth = window.innerWidth;
                this.changeNavItems(this.screenWidth);
            });
        },
        changeNavItems(width) {
            if (width < 1025) {
                this.isFixed = true;
                this.navItems = [
                    {
                        name: this.user ? this.user.name : '',
                        link: '/profile',
                    },
                    {
                        name: 'Оформить ОСАГО',
                        link: '/dashboard',
                    },
                    {
                        name: 'Вопрос-ответ',
                        link: '/osago_faq',
                    },
                    {
                        name: 'О компании',
                        link: '/osago_company',
                    },
                    {
                        name: 'Новости',
                        link: '/news',
                    },
                    {
                        name: this.user ? '' : 'Пользователям и партнерам',
                        link: 'tel:+78003507261',
                    },
                    {
                        name: 'Блог',
                        link: '/blog',
                    },
                    {
                        name: 'Контакты',
                        link: '/osago_contacts',
                    },
                    {
                        name: this.user ? '' : '8 800 350 72 61',
                        link: 'tel:+78003507261',
                    },
                ]
            } else {
                this.isFixed = false;
                this.navItems = [
                    {
                        name: '8 800 350 72 61',
                        link: 'tel:+78003507261',
                    },
                    {
                        name: this.user ? '' : 'Пользователям и партнерам',
                        link: '/b2b',
                    },
                    {
                        name: this.user ? 'Вопросы' : '',
                        link: '/osago_faq',
                    },
                    {
                        name: this.user ? 'Блог' : '',
                        link: '/blog',
                    },
                    {
                        name: this.user ? '' : 'О нас',
                        link: '/osago_company',
                    },
                    {
                        name: this.user ? this.user.name : '',
                        link: '/profile',
                    },
                ]
            }
        },
        openLink(url) {
            window.open(url, '_self');
        },
        signOut() {
            if (this.user) {
                axios.post('/logout')
                    .then(function (response) {
                        console.log(response);
                        window.open('/login', '_self');
                    })
                    .catch(function (error) {
                        console.log(error);
                        window.open('/login', '_self');
                    });
            } else {
                window.open('/login', '_self');
            }
        },
        changeDialog(value) {
            this.toDisplay = value
        },
        copyUserId() {
            const toCopy = this.modifiedUserId;

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(toCopy)
                    .then(() => {
                        PNotify.success('ID скопирован!');
                    })
                    .catch(() => {
                        PNotify.error('Ошибка копирования');
                    });
            } else {
                // fallback для старых браузеров
                let textarea = document.createElement("textarea");
                textarea.value = toCopy;
                textarea.style.position = "fixed";
                textarea.style.opacity = 0;
                document.body.appendChild(textarea);
                textarea.select();

                try {
                    document.execCommand("copy");
                    PNotify.success('ID скопирован!');
                } catch (err) {
                    PNotify.error('Ошибка копирования');
                }

                document.body.removeChild(textarea);
            }
        },
    },
    computed: {
        formattedUserId() {
            return this.user ? String(this.user.id).padStart(5, "0") : "";
        },
        modifiedUserId() {
            return "GP" + this.formattedUserId + "CD";
        }
    },
}
</script>

<style scoped>
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

li {
    list-style: none;
}

header {
    min-height: 70px;
    background-color: #FFFFFF;
}

a {
    color: #000000;
    text-decoration: none;
    cursor: pointer;
}

.curator {
    display: flex;
    flex-direction: row;
    gap: 14px;
}

.nav-item {
    font-family: 'SFUIDisplay', Arial, sans-serif;
    font-weight: 700;
    font-size: 16px;
}

.navbar {
    min-height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    background-color: #fff;
    width: 100%;
    z-index: 100;
    transition: all 0.5s ease-in-out;
    top: -70px;
    position: static;
}

.fixed-navbar {
    position: fixed;
    top: 0;
    transition: all 0.3s ease-in-out;
}

.nav-logo {
    max-width: 160px;
    width: 100%;
}

.nav-menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 30px;
}

.hamburger {
    display: none;
    cursor: pointer;
}

.bar {
    display: block;
    width: 25px;
    height: 3px;
    margin: 5px auto;
    -webkit-transition: all 0.3s ease-in-out;
    background-color: #000000;
}

.submit-button {
    font-size: 14px;
    font-family: 'SFUIDisplay', Arial, sans-serif;
    text-transform: none !important;
    box-shadow: none !important;
    color: #ffffff;
    background-color: #00ba57 !important;
    font-weight: 700;
    border-radius: 20px;
    height: 40px;
    padding: 0 30px;
    -webkit-border-radius: 20px;
}

.sign-button {
    font-size: 16px;
    color: #000000;
    border: 1px solid #c7c7c7;
    background-color: #ffffff;
    border-radius: 30px;
    -moz-border-radius: 30px;
    -webkit-border-radius: 30px;
    font-family: SFPro, Arial, sans-serif;
    font-weight: 400;
    padding: 8px 30px;
}

.user-id-tooltip {
    position: relative;
    cursor: pointer;
    font-weight: 600;
}

/* Тултип под текстом */
.user-id-tooltip::after {
    content: attr(data-user-id);
    position: absolute;
    top: -28px;
    right: -15px;
    padding: 3px 6px;
    background: #000;
    color: #fff;
    font-size: 12px;
    border-radius: 4px;
    white-space: nowrap;
    opacity: 0;
    transform: translateY(5px);
    transition: opacity .25s ease, transform .25s ease;
    pointer-events: none;
}

.user-id-tooltip:hover::after {
    opacity: 1;
    transform: translateY(0);
}

.copy-notice {
    position: fixed;
    top: 20px;
    right: 20px;
    background: #000;
    color: #fff;
    padding: 10px 18px;
    border-radius: 6px;
    opacity: 0;
    transition: opacity .4s ease;
    z-index: 999999; /* <— Важно */
}

.copy-notice.show {
    opacity: 1;
}

@media (max-width: 1400px) {
    .curator {
        display: none;
    }
}

@media (max-width: 1024px) {
    .navbar {
        padding: 0 20px;
    }

    .nav-logo {
        height: 55px;
    }

    .hamburger {
        display: block;
    }

    .hamburger.active .bar:nth-child(2) {
        opacity: 0;
    }
    .hamburger.active .bar:nth-child(1) {
        transform: translateY(8px) rotate(45deg);
    }
    .hamburger.active .bar:nth-child(3) {
        transform: translateY(-8px) rotate(-45deg);
    }

    .nav-menu {
        position: fixed;
        left: -100%;
        top: 70px;
        gap: 0;
        flex-direction: column;
        background-color: #ffffff;
        width: 100%;
        text-align: center;
        transition: 0.2s;
        height: 100vh;
        display: flex;
        justify-content: flex-start;
        padding-top: 150px;
    }

    .nav-menu a {
        font-size: 20px;
        font-weight: 500;
        font-family: 'SFPro', Arial, sans-serif;
    }

    .nav-menu .nav-item:first-child a {
        font-size: 20px;
        font-weight: 700;
        font-family: 'SFPro', Arial, sans-serif;
    }
    .nav-menu .nav-item:last-child {
        margin-top: 70px;
    }
    .nav-menu .nav-item:last-child a {
        font-family: 'SFUIDisplay', Arial, sans-serif;
    }

    .curator {
        display: none;
    }

    .nav-item {
        margin: 10px 0;
    }

    .nav-menu.active {
        height: 100vh;
        left: 0;
        z-index: 1000;
        display: flex;
        justify-content: flex-start;
        padding-top: 150px;
    }

    .user-id-tooltip {
        font-size: 20px;
        font-weight: 500;
        font-family: 'SFPro', Arial, sans-serif;
    }
}

.header__container {
    padding: 0 30px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/elements/HeaderComponent.vue